import { DeepPartial } from 'react-hook-form/dist/types/utils';

export function upsertCollectionElement<T extends { id: string | number }>(
  collection: T[],
  updatedElement: T,
): T[] {
  const elementIndex = collection.findIndex(
    (element) => element.id === updatedElement.id,
  );
  return elementIndex >= 0
    ? [
        ...collection.slice(0, elementIndex),
        updatedElement,
        ...collection.slice(elementIndex + 1),
      ]
    : [...collection, updatedElement];
}

let _isElectron = false;
export function setIsElectron(value: boolean) {
  _isElectron = value;
}
export function isElectron() {
  return _isElectron;
}

export function parseIntOrDefault(
  t: string | undefined | null,
  defaultValue: number,
): number;
export function parseIntOrDefault(t: string, defaultValue: number): number;
export function parseIntOrDefault(t: string): number;
export function parseIntOrDefault(
  t: string | undefined | null,
): number | undefined | null;
export function parseIntOrDefault(
  t: string | undefined | null,
  defaultValue?: number,
): number | undefined {
  if (t === undefined || t === null) return defaultValue;
  const result = parseInt(t);
  if (isNaN(result)) {
    if (defaultValue === undefined)
      throw new Error(`Can't parse '${t}' to a number`);
    return defaultValue;
  }
  return result;
}
// to have a non-changing empty array (to prevent re-renderings)
const emptyArraySingleton: unknown[] = [];
export function emptyArray<T>(): T[] {
  return emptyArraySingleton as T[];
}
